export const API_URL = {
  USER: "/users",
  INSTANCE: "/instances",
  APPROVAL: "/approvals",
  AUTHENTICATION: "/authentication",
  OAUTH: "/oauth",
  PASSKEY: "/passkey",
  LOGIN: "/login",
  TOKEN: "/tokens",
  INITIALIZE: "/initialize-firebase",
};
